import { render, staticRenderFns } from "./EditProductItemQuantity.vue?vue&type=template&id=13fdc229&scoped=true&lang=pug&"
import script from "./EditProductItemQuantity.vue?vue&type=script&lang=js&"
export * from "./EditProductItemQuantity.vue?vue&type=script&lang=js&"
import style0 from "./EditProductItemQuantity.vue?vue&type=style&index=0&id=13fdc229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fdc229",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow,VTextField})
